import { app } from "hyperapp";
import actions from "./actions";
import view from "./view";
import { formatHMS } from "../utilities";
// Playable components
import EpisodePlayer from "./episode-player";
import PlayerButtons from "./player-buttons";

function resolveComponent(type) {
  return {
    episode_player: EpisodePlayer,
    player_buttons: PlayerButtons
  }[type];
}

function deriveInitialState(props) {
  let { formattedDuration } = props;
  let duration = null;
  const firstItem = props.items[0];
  let { type } = firstItem;
  // Clips can be fragments or mp3
  if (type === "clip") {
    type = firstItem.data.duration != null ? "fragment" : "audio_archive_item";
  }
  if (type === "broadcast_episode" || type === "fragment") {
    duration = firstItem.data.duration;
  } else if (type === "podcast_episode" || type === "audio_archive_item") {
    duration = firstItem.data.audio_file.duration;
  } else if (type === "shared_audio_item") {
    duration = firstItem.data.duration;
    // Ensure duration is within bounds
    // Duration is in seconds and offsets are in milliseconds
    if (
      firstItem.data.original_item.type === "clip" &&
      firstItem.data.original_item.data.audio_file
    ) {
      const audioFileDuration =
        firstItem.data.original_item.data.audio_file.duration;
      if (audioFileDuration < duration) {
        duration = audioFileDuration - firstItem.data.start_offset / 1000;
        formattedDuration = formatHMS(duration, duration >= 3600 ? "h" : "m");
      }
    } else {
      if (firstItem.data.original_item.data.duration < duration) {
        duration =
          firstItem.data.original_item.data.duration -
          firstItem.data.start_offset / 1000;
        // Avoid cases of total insane URLs
        duration =
          duration <= 0 ? firstItem.data.original_item.data.duration : duration;
        formattedDuration = formatHMS(duration, duration >= 3600 ? "h" : "m");
      }
    }
  }

  return {
    duration,
    formattedDuration
  };
}

/**
 * View-loader component for loading all playables
 * @param {DOMNode} el Node to bind to
 * @param {Object} props Options
 */
export default function playable(el, props) {
  let { component } = props;
  if (el.getAttribute("initialised") === "true") {
    return;
  }
  el.setAttribute("initialised", "true");

  component = resolveComponent(component);

  if (component) {
    const initialState = {
      destroyed: false,
      isPlaying: false,
      isCurrentItem: false,
      currentTime: null,
      remaining: null,
      duration: null,
      elapsedPercentage: null,
      formattedCurrentTime: null,
      formattedDuration: null,
      formattedRemaining: null,
      ...props,
      ...deriveInitialState(props),
      component
    };
    let instance = app(initialState, actions, view, el);
    return {
      destroy: () => {
        instance.destroy();
        instance = null;
      }
    };
  }
}
